import { useMutation, useQueryClient } from '@tanstack/react-query';
import { BookingService, CreateBookingRequest } from '@/services/booking.service';
import { logger } from '@/utils/logger';

export const useCreateBooking = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (bookingData: CreateBookingRequest) =>
      BookingService.createBooking(bookingData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['bookings'] });
    },
    onError: (error: Error) => {
      // Phase 87 BOOKING-04: log for observability but re-throw via React Query's
      // default behavior so consumers can read `mutation.error.message`.
      logger.error('Booking creation failed:', error.message);
    },
  });
};
